const initialState = {
    seller: null,
    loading: false,
    error: null,
  };
  
  const shopReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOP_REQUEST":
        return { ...state, loading: true };
      case "SHOP_SUCCESS":
        return { ...state, loading: false, seller: action.payload };
      case "SHOP_FAIL":
        return { ...state, loading: false, error: action.payload };
      case "SHOP_LOGOUT":
        return initialState;
      default:
        return state;
    }
  };
  
  export default shopReducer;
  